import React from 'react';

import ReactDOM from 'react-dom/client';

import App from './MainApp';
import { ThemeProvider } from './context/ThemeContext';

import axios from 'axios';

// CSS is injected directly via public/index.html

// Configuración global de Interceptores de Axios
axios.interceptors.request.use(
    (config) => {
        // Redirigir localhost:4000 a la ruta relativa en producción
        if (config.url && config.url.startsWith('http://localhost:4000')) {
            const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
            if (!isLocal) {
                config.url = config.url.replace('http://localhost:4000', '');
            }
        }

        // 1. Inyectar Token JWT
        const token = localStorage.getItem('token');

        if (token) {
            config.headers['Authorization'] = `Bearer ${token
                }`;
        }

        // 2. Inyectar Project ID Activo (Tenant Context)
        const activeProjectId = localStorage.getItem('activeProjectId');

        if (activeProjectId) {
            config.headers['X-Project-ID'] = activeProjectId;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            console.error("Acceso denegado o sesión expirada.");


            // Si la URL actual no es /login, y nos da 401, redirigimos
            if (window.location.pathname !== '/login') {
                localStorage.removeItem('token');

                localStorage.removeItem('userRole');

                window.location.href = '/login';
            }
        }

        // Si el servidor retorna 503 Service Unavailable (Modo Mantenimiento activo)
        if (error.response && error.response.status === 503) {
            if (window.location.pathname !== '/maintenance') {
                window.location.href = '/maintenance';
            }
        }
        return Promise.reject(error);
    }
);


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <ThemeProvider>
            <App />
        </ThemeProvider>
    </React.StrictMode>
);

